/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (s) {
  return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
    s
  )
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^1[3-9]\d{9}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/**
 * 正整数
 * @param {*} s
 */
export function isInt (s) {
  return /^\d+$/.test(s)
}

/**
 * 正整数
 * @param {*} s
 */
export function isMoney (s) {
  return /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(s)
}

/**
 * 判断是否为数字,整数或小数点后3位
 * @param {*} s
 * @returns
 */
export function isNumber (s) {
  return /(^-*[1-9]\d*(\.\d{1,3})?$)|(^-*0(\.\d{1,3})?$)/.test(s)
}

/**
 * 判断是否为正数,整数或小数点后3位
 * @param {*} s
 * @returns
 */
export function isPositiveNumber (s) {
  return /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/.test(s)
}

export function moneyValidator (rule, value, callback, source, options, msg) {
  var priceReg = /(^-{0,1}[1-9]\d*(\.\d{1,8})?$)|(^0(\.\d{1,8})?$)/
  if (value && !priceReg.test(value)) {
    callback(new Error(msg || '请输入正确的金额'))
  }
  callback()
}

export function countValidator (rule, value, callback, source, options, msg) {
  if (value && !isNumber(value)) {
    callback(new Error(msg || '请输入正确的数字'))
  }
  callback()
}

/**
 * 单价验证,全局单价精确到小数点后3位
 * @param rule
 * @param value
 * @param callback
 * @param source
 * @param options
 * @param msg
 */
export function priceValidator (rule, value, callback, source, options, msg) {
  var priceReg = /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/
  if(value){
    let p=parseFloat(value)
    if(isNaN(p)){
      callback(new Error(msg || '请输入正确的数字'))
    }else if(p<0){
      callback(new Error(msg || '单价不能小于0'))
    }else if(!priceReg.test(value)){
      callback(new Error(msg || '只支持小数点后3位'))
    }
  }
  callback()
}
